import { sizing } from "ds_legacy/materials/metrics";
import { disabledFlagStyle } from "./index";

export default function DevFlag({ isActive }: { isActive?: boolean }) {
  const baseStyle = { fontSize: sizing(3) };
  const style = { ...baseStyle, ...(!isActive ? disabledFlagStyle : {}) };
  return <span style={style}>🗺️</span>;
}
